module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/3-3a54f505e985c3a6e30ee9abc28dadcc.svg";